<template>
    <element-wrapper
        icon="fas fa-file has-text-grey-light"
        kind="note"
        :is_active="is_active"
        :is_child="parent_id"
        :draggable="true"
        :id="note.id"
        @open="open">

        <span v-if="note.name">{{note.name}}</span>
        <i v-else class="has-text-grey">Untitled</i>

        <template
            slot="dropdown"
            v-if="space_permission('NOTE_UPDATE') || space_permission('NOTE_DELETE')">

            <a v-if="space_permission('NOTE_UPDATE')"
               @click.stop="moving_note = note"
               class="dropdown-item">
                <i class="icon fas fa-reply"></i> Move to ...
            </a>

            <a v-if="space_permission('NOTE_DELETE')"
               @click.stop="show_confirm = true"
               class="dropdown-item">

                <i class="icon fas fa-trash-alt"></i> Delete
            </a>
        </template>

        <note-move-modal
            :space="space"
            :note="moving_note"
            @close="moving_note = null"
            @moved="moved"/>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to move this note to trash?"
            @close="show_confirm = false"
            @ok="remove"/>
    </element-wrapper>
</template>

<script>
import { copy } from '../../utils/helpers';
import ElementWrapper from '../common/ElementWrapper.vue';
import NoteMoveModal from '../note/NoteMoveModal.vue';

export default {
    name: 'TreeNote',
    components: { NoteMoveModal, ElementWrapper },
    props: ['space', 'note', 'parent_id'],
    data() {
        return { show_dropdown: false, moving_note: null, show_confirm: false };
    },
    computed: {
        is_active() {
            return parseInt(this.$route.query.note, 10) === this.note.id;
        },
        topic_id() {
            return parseInt(this.$route.query.topic, 10);
        },
    },
    methods: {
        open() {
            this.$store.commit('tree/open_note', { topic_id: this.topic_id, note_id: this.note.id });
            const query = copy(this.$route.query);
            query.note = this.note.id;
            this.$router.replace({ name: 'content', params: this.$route.params, query });
        },
        async remove() {
            await this.$store.dispatch('notes/remove', { space_id: this.space.id, note_id: this.note.id });
            this.$store.commit('tree/remove_item', { id: this.note.id, kind: 'note' });
            this.$store.commit('tree/remove_open_note', this.note.id);
            this.$store.commit('notes/clean_detail', this.note.id);
        },
        moved() {
            this.$store.commit('tree/remove_item', { id: this.note.id, kind: 'note' });
            this.moving_note = null;
        },
    },
};
</script>
